var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "big" },
    [
      _c(
        "el-form",
        { attrs: { inline: true, "label-position": "top" } },
        [
          _c(
            "el-form-item",
            { attrs: { label: "应用名称" } },
            [
              _c(
                "el-select",
                { attrs: { placeholder: "应用名称", clearable: "" } },
                [_c("el-option")],
                1
              ),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "开始时间" } },
            [
              _c("el-date-picker", {
                attrs: { type: "date", placeholder: "开始时间" },
              }),
              _c("p", { staticClass: "export-tip" }, [
                _vm._v("统计时区：印度"),
              ]),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "结束时间" } },
            [
              _c("el-date-picker", {
                attrs: { type: "date", placeholder: "结束时间" },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            [_c("el-button", { attrs: { type: "primary" } }, [_vm._v("搜索")])],
            1
          ),
          _c("el-form-item", [_c("el-button", [_vm._v("导出")])], 1),
        ],
        1
      ),
      _c("p", { staticClass: "export-tip staticsTip" }, [
        _vm._v(
          "* 由于统计数据与实际数据和用户交易行为之间存在时间差异，因此今天的数据仅供参考."
        ),
      ]),
      _c(
        "el-table",
        [
          _c("el-table-column", { attrs: { label: "创建时间" } }),
          _c("el-table-column", { attrs: { label: "用户ID" } }),
          _c("el-table-column", { attrs: { label: "应用 ID" } }),
          _c("el-table-column", { attrs: { label: "应用名称" } }),
          _c("el-table-column", { attrs: { label: "平台订单号" } }),
          _c("el-table-column", { attrs: { label: "" } }),
        ],
        1
      ),
      _c("el-pagination", {
        attrs: {
          "current-page": _vm.currentPage4,
          "page-sizes": [100, 200, 300, 400],
          "page-size": 100,
          layout: "total, sizes, prev, pager, next, jumper",
          total: 400,
        },
        on: {
          "size-change": _vm.handleSizeChange,
          "current-change": _vm.handleCurrentChange,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }